export default "__VITE_ASSET__KfPP2y7J__"